import Tooltip from "../components/ui/tooltip";
export default Tooltip;